type ApolloOperationReportInput = {
  operationName?: unknown;
  variables?: unknown;
};

type ApolloErrorConsoleSummaryInput = {
  graphQLErrorCount: number;
  hasNetworkError: boolean;
  operationName?: unknown;
};

const locallyHandledApolloErrorOperations = new Set([
  "reactivateMemberProfileAndPerksBannersForChamberMember",
  "reactivateBannerForCategoryAdvertisingBanner",
  "getChamberForMemberLogin",
  "recordCmpMemberDashboardLogin",
  "recordCpaDashboardAccess",
  "sendLoginInfoEmailToChamberMember",
  "ActivateCmpMember",
  "SuspendCmpMember",
  "getCmpMemberInvoices",
  "getCmpMemberInvoiceDetail",
  "getCmpMemberInvoiceDocument",
  "startCmpMemberInvoiceCheckout",
]);

const getOperationName = (operationName: unknown): string =>
  typeof operationName === "string" && operationName.trim()
    ? operationName.trim()
    : "unknown";

/**
 * Error reports can identify the GraphQL input shape, but must not include
 * customer or credential values from the operation variables.
 */
export const getApolloOperationReportContext = ({
  operationName,
  variables,
}: ApolloOperationReportInput): {
  operationName: string;
  variableNames: string[];
} => ({
  operationName: getOperationName(operationName),
  variableNames:
    variables && typeof variables === "object" && !Array.isArray(variables)
      ? Object.keys(variables as Record<string, unknown>).sort()
      : [],
});

export const getApolloErrorConsoleSummary = ({
  graphQLErrorCount,
  hasNetworkError,
  operationName,
}: ApolloErrorConsoleSummaryInput): {
  graphQLErrorCount: number;
  hasNetworkError: boolean;
  operationName: string;
} => ({
  graphQLErrorCount,
  hasNetworkError,
  operationName: getOperationName(operationName),
});

export const isApolloErrorHandledLocally = (
  operationName: unknown
): boolean =>
  typeof operationName === "string" &&
  locallyHandledApolloErrorOperations.has(operationName);
